import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/esm/typeof";
var _excluded = ["vids"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { ComponentType } from './WebFormItem';
export var emailValidator = function emailValidator(value) {
  var reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value && reg.test(value)) {
    return;
  }
  return 'Invalid email address';
};
/** 长度校验 return true 为校验失败， return undefined 为校验成功 */

export var lengthValidator = function lengthValidator(value, info) {
  var l = (value === null || value === void 0 ? void 0 : value.length) || 0;
  if (l === 0) {
    if (info.required) {
      return 'This field is required';
    } else {
      return;
    }
  }
  if (info.minLength && l < info.minLength) {
    return 'Please enter at least ' + info.minLength + ' characters';
  }
  if (info.maxLength && l > info.maxLength) {
    return 'Please enter no more than ' + info.maxLength + ' characters';
  }
  return;
};
var mediaValidator = function mediaValidator(valueList, required) {
  return required ? (valueList === null || valueList === void 0 ? void 0 : valueList.length) > 0 : true;
};
/** 根据表单元素类型进行值的校验 */

export var isValidValue = function isValidValue(value, info) {
  if ([ComponentType.MixedFileUpload].includes(info.component)) {
    var _value$imagesList, _value$videosList, _info$imageProps, _info$videoProps;
    if (info !== null && info !== void 0 && info.required && (value === undefined || (value === null || value === void 0 ? void 0 : (_value$imagesList = value.imagesList) === null || _value$imagesList === void 0 ? void 0 : _value$imagesList.length) === 0 && (value === null || value === void 0 ? void 0 : (_value$videosList = value.videosList) === null || _value$videosList === void 0 ? void 0 : _value$videosList.length) === 0)) {
      return false;
    }
    return mediaValidator(value === null || value === void 0 ? void 0 : value.imagesList, info === null || info === void 0 ? void 0 : (_info$imageProps = info.imageProps) === null || _info$imageProps === void 0 ? void 0 : _info$imageProps.required) && mediaValidator(value === null || value === void 0 ? void 0 : value.videosList, info === null || info === void 0 ? void 0 : (_info$videoProps = info.videoProps) === null || _info$videoProps === void 0 ? void 0 : _info$videoProps.required);
  }
  if ((value === undefined || (value === null || value === void 0 ? void 0 : value.length) === 0) && !info.required) {
    return true;
  } // harcode 两种特殊组件类型

  if ([ComponentType.RequestEmail].includes(info.component)) {
    return !emailValidator(value === null || value === void 0 ? void 0 : value[1]) && !lengthValidator(value === null || value === void 0 ? void 0 : value[1], info);
  }
  if ([ComponentType.Email].includes(info.component)) {
    return !emailValidator(value) && !lengthValidator(value, info);
  }
  if ([ComponentType.InputWithRegion].includes(info.component)) {
    return !lengthValidator(value === null || value === void 0 ? void 0 : value[1], info) && !!(value !== null && value !== void 0 && value[1]);
  }
  if (typeof value === 'string') {
    return value.trim() !== '' && !lengthValidator(value.trim(), info);
  } else {
    return (value === null || value === void 0 ? void 0 : value.length) > 0;
  }
};
/**
 * 创建一个纯函数缓存
 */

export function cached(fn) {
  var cache = Object.create(null);
  return function (str, extra) {
    var hit = cache["".concat(str).concat(extra || '')];
    return hit || (cache["".concat(str).concat(extra || '')] = fn(str, extra));
  };
}
/**
 * 去掉下划线并全小写
 */

var camelizeLowerRE = /[_-](\w)/g;
export var camelizeLower = cached(function (str) {
  return (str || '').toLowerCase().replace(camelizeLowerRE, function (_, c) {
    return c;
  });
});
/**
 * 是否是纯对象
 */

export function isPlainObject(val) {
  return val && _typeof(val) === 'object' && !Array.isArray(val);
}
/**
 * 对象key去掉下划线并全小写
 *
 * @param {*} obj
 * @returns {Record<string, unknown>}
 */

var toHumpLower = function toHumpLower(obj) {
  var newObj = {};
  Object.keys(obj).forEach(function (key) {
    if (Array.isArray(obj[key])) {
      newObj[camelizeLower(key)] = obj[key].map(function (o) {
        return toHumpLower(o);
      });
    } else if (isPlainObject(obj[key])) {
      newObj[camelizeLower(key)] = toHumpLower(obj[key]);
    } else {
      newObj[camelizeLower(key)] = obj[key];
    }
  });
  return newObj;
};
var isObject = function isObject(value) {
  var type = _typeof(value);
  return value != null && (type === 'object' || type === 'function');
}; // 去掉参数 key 中的下划线

var replaceUnderscore = function replaceUnderscore(obj) {
  if (isObject(obj)) {
    var res = Array.isArray(obj) ? [] : {};
    var _iterator = _createForOfIteratorHelper(Reflect.ownKeys(obj)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var currentKey = key;
        if (typeof key === 'string') {
          currentKey = key.replace(/\_/g, '');
        }
        res[currentKey] = isObject(obj[key]) ? replaceUnderscore(obj[key]) : obj[key];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return res;
  }
  return obj;
}; // 格式化从后端获取的 token 和 vid

export var formatMediaTokens = function formatMediaTokens(_ref) {
  var vids = _ref.vids,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (vids || []).map(function (vid) {
    return JSON.stringify(toHumpLower(_objectSpread({
      vid: vid
    }, rest)));
  });
}; // 过滤掉Object对象中的空value对应的键值对

export var filterNullObj = function filterNullObj(obj) {
  var newObj = {};
  for (var item in obj) {
    if (!(typeof obj[item] === 'undefined' || obj[item] === null || obj[item] === '')) {
      newObj[item] = obj[item];
    }
  }
  return newObj;
};
export var addFileProtocol = function addFileProtocol(path) {
  if (!path) {
    return '';
  }
  if (!path.startsWith('file://')) {
    return "file://".concat(path);
  }
  return path;
};